import axios from './_axios';
import entrypoints from './_entrypoints';
import { dateToApiDate, getData, reduceToSingleNewspaper } from '../shared/functions';
/**
 * API call to retrieve a single newspaper by id
 * @return {Promise<Newspaper>}
 */
var getNewspaperByPublicationIdAndDate = function (id, date) { return axios
    .get(entrypoints.newspaper, { params: { id: id, date: dateToApiDate(date) } })
    .then(getData)
    .then(reduceToSingleNewspaper()); };
export default getNewspaperByPublicationIdAndDate;
